/**
 * Regex pattern that only allows letters and commas (no numbers, special characters, emails)
 */
const LETTERS_ONLY_PATTERN = /^[a-zA-Z]+$/;

/**
 * Sanitizes a watcher string by trimming whitespace
 * 
 * @param {string} watcher - The watcher string to sanitize
 * @returns {string} - The trimmed watcher string
 */
export const sanitizeWatcher = (watcher: string): string => {
    return watcher.trim();
};

/**
 * Validates that a watcher string contains only letters
 * 
 * @param {string} watcher - The watcher string to validate
 * @returns {boolean} - True if watcher contains only letters, false otherwise
 */
export const validateWatcher = (watcher: string): boolean => {
    return LETTERS_ONLY_PATTERN.test(watcher);
};